<template lang="pug">
  .table-responsive
    table.table.is-fullwidth.is-narrow
      thead
        tr
          th #
          th Descripción
          th Solicita
          th Atiende
          th Problema / Resolución
          th Estado
      tbody
        tr(v-for="( t, index ) in tickets" :key="t.id")
          td 
            a.button.is-black.is-small.is-rounded(@click="irDetalle(t)") {{ index + 1 }}
          td
            strong.is-size-7 {{ t.equipo }}
            br
            span.tag.is-warning(v-show="t.marca !=='' && t.modelo !==''") {{ t.marca}} | {{ t.modelo }}
            | &nbsp
            br
            | &nbsp
            span.tag.is-light(v-show="t.serie !== ''") {{ t.serie}}
          td 
            strong.is-size-7 {{ t.solicita }}
            br
            span.tag.is-light {{ t.ubicacion }}
            | &nbsp
            br
            span.tag {{getDepartamento(t.departamento)}}
          td
            .fiel.is-grouped.is-grouped-multiline
              .control
                span.tag.is-rounded(v-for="uAt in t.atiende" v-show="uAt.idAtiende === t.idResuelve" :class="uAt.idAtiende === t.idResuelve ? 'is-black': ''") 
                  | {{ uAt.nombre }}
          td
            span.tag.is-dark
              | {{ `P: ${t.fechaReg}: ${t.problema}` }}
            br
            span.tag.is-light(v-show="t.fechaResolucion!==''")
              | {{ `D: ${t.fechaResolucion}: ${t.comentarios}` }}
            br(v-show="t.fechaRes!==''")
            button.button.is-text.is-small(v-show="t.id_actividad!==''" @click="imprimirReporte(t)")
              | {{ t.id_actividad }}
            br(v-show="t.id_actividad!==''")
            span.tag.is-warning(v-show="t.fechaRes!==''") {{ getDiagnostico(t.diagnostico) }}
          td
            span.tag(:class="getClassEstado(t.estado)" @click="atenderTicket(t)")
              | {{ getTextEstado(t.estado) }}
            | &nbsp
            span(v-html="getClassCompra(t)" @click="showModalCompra(t)")
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'Tb_Tickets',
    props: {
      tickets: {
        type: Array,
        default: []
      },
    },
    methods: {
      getPersonAtiende (ticket) {
        let stringPerson = ''
        ticket.atiende.forEach(element => {
          stringPerson += `<span class="tag is-light">${element.nombre}</span>&nbsp`
        })
        return stringPerson
      },
      getDepartamento (depto) {
        let stringDepto = ''
        switch (depto) {
          case 0:
            stringDepto =  'Gerencia'
            break
          case 1:
            stringDepto =  'Instrumentación'
            break
          case 2:
            stringDepto =  'Administración'
            break
          case 3:
            stringDepto =  'Sistemas'
            break
          case 4:
            stringDepto =  'Operación'
            break
          case 5:
            stringDepto =  'Mantenimiento'
            break
          case 6:
            stringDepto =  'Instrum. - Sistmas'
            break
          case 7:
            stringDepto =  'Seguridad'
            break
          case 8:
            stringDepto =  'Externo'
            break
          case 9:
            stringDepto =  'Público'
            break
          case 21:
            stringDepto =  'Contraloría'
            break
          case 22:
            stringDepto =  'Contabilidad'
            break
          case 23:
            stringDepto =  'Cuentas por pagar'
            break
          case 24:
            stringDepto =  'Fiscal'
            break
          case 25:
            stringDepto =  'Legal'
            break
          case 71:
            stringDepto =  'Seguimiento Ambiental'
            break
          case 72:
            stringDepto =  'Regulación'
            break
          case 73:
            stringDepto =  'Procesos y Proc.'
            break

          default:
            break
        }
        return stringDepto
      },
      getClassEstado(est) {
        let html = ''
        switch (est) {
          case 0:
            html = 'is-danger'
            break
          case 1:
            html = 'is-dark'
            break
          case 2:
            html = 'is-light'
            break 
          case 3:
            html = 'is-success'
            break 
          case 4:
            html = 'is-light'
            break 
          case 5:
            html = 'is-black'
            break
          case 6:
            html = 'is-black'
            break
        }
        return html
      },
      getTextEstado(est) {
        let estadoStr = ''
        switch (est) {
          case 0:
            estadoStr = 'Pendiente'
            break
          case 1:
            estadoStr = 'Atendida'
            break
          case 2:
            estadoStr = 'Sol. Rechazada'
            break 
          case 3:
            estadoStr = 'Comprar'
            break 
          case 4:
            estadoStr = 'No Autorizada'
            break
          case 5:
            estadoStr = 'Autorizada'
            break 
          case 6:
            estadoStr = 'En Compra'
            break 
          case 7:
            estadoStr = 'En Compra'
          break 
          case 8:
            estadoStr = 'En Compra'
            break
          case 9:
            estadoStr = 'En Compra'
            break
          case 10:
            estadoStr = 'En Compra'
            break
          case 11:
            estadoStr = 'En Almacén'
            break
          case 12:
            estadoStr = 'Asignado'
            break
        }
        return estadoStr
      },
      irDetalle (ticket) {
        if (ticket.idResuelve === this.userLogin.id) {
          if (ticket.estado < 2) {
            console.log('Aun se puede editar')
            this.$store.commit('atenderTicket', ticket)
            this.$router.push({ path: `/Soporte/Detalle`})
          } else {
            console.log('Ya no se puede editar')
          }
        }
      },
      changeEstado (id, est, areA) {

        if (this.userLogin.cargo === '003' ) {
          this.cambiarEstadoModal(id, est)
          this.ticketSelect = id
          this.titleModal = 'Cambiar Estado'
          this.contentModal = '¿Desea Cambiar el estado del Ticket?'
          this.modalStatus = true
          this.actualModal = est
          return
        }
        
        if (this.userLogin.departamento === areA) {
            console.log(id)
            this.ticketSelect = id
            this.titleModal = 'Cambiar Estado'
            this.contentModal = '¿Desea Cambiar el estado del Ticket?'
            this.modalStatus = true
            this.actualModal = est
        } else{
          console.log('No esta permitido para usuarios')
          this.modalStatus = false
        }
      },
      cambiarEstadoModal(id, est) {
        
      },
      atenderTicket(ticket) {
        if (this.userLogin.departamento === 1 || this.userLogin.departamento === 3 || this.userLogin.departamento === 6) {
          let newTicket = {}

          if (ticket.estado > 0) {
            console.log(`ticket.idAtiende ${ticket.idAtiende} | user.id ${this.userLogin.id}`)
            if (ticket.idAtiende === this.userLogin.id) {
              console.log(`Ticket | Edit: true | authorized: true`)
              newTicket = this.converEditado(ticket, true, true)
            } else {
              console.log(`Ticket | Edit: false | authorized: false`)
              newTicket = this.converEditado(ticket, false, false)
            }
          } else {
            const canAttend = ticket.atiende.some(tick => tick.idAtiende === this.userLogin.id)
            console.log(`Ticket | Edit: false | authorized: ${canAttend}`)
            newTicket = this.converEditado(ticket, false, canAttend)
          }
          this.$store.commit('atenderTicket', newTicket)
          this.$router.push('/Soporte/Atencion')
        }
      },
      converEditado(ticket, isEdit, authorized) {
        return {
          ...ticket,
          editado: isEdit,
          authorized: authorized
        }
      },
      getDiagnostico(d) {
        switch (d) {
          case 0:
            return 'No se puede reparar'
          case 1:
            return 'Reparado'
          case NaN:
            return ''
        }
      },
      showModalCompra(ticket) {
        if (ticket.compra === 1) {
          console.log(parseInt(this.userLogin.categoria))
          if (this.userLogin.categoria == 2 || this.userLogin.categoria == 0) {
            switch (true) {
              case (this.userLogin.categoria === 0 && this.userLogin.departamento === 6):
                this.$emit('showModalCompra', ticket)
                break
              case (this.userLogin.categoria == 2 && ticket.estado == 1):
                this.$emit('showModalCompra', ticket)
                break
              case (this.userLogin.categoria == 2 && ticket.estado == 2):
                this.$emit('showModalCompra', ticket)
                break
              case (this.userLogin.categoria == 2 && ticket.estado == 3):
                this.$emit('showModalCompra', ticket)
                break
              case (this.userLogin.categoria == 2 && ticket.estado == 5):
                this.$emit('showModalCompra', ticket)
                break
            
              default:
                console.log(`Sin derecho Cat: ${this.userLogin.categoria} | estado ticket: ${ticket.estado}`)
                break
            }
          }
        }
      },
      getClassCompra(t) {
        console.log(`Estado: ${t.estado} | Compra: ${t.compra}`)
        switch (true) {
          case (t.estado == 1 && t.compra == 1):
            return '<span class="tag is-warning">Para compra</span>'
          case (t.estado == 2 && t.compra == 1):
            return '<span class="tag is-warning">Para compra</span>'
          case (t.estado == 3 && t.compra == 1):
            return '<span class="tag is-warning">Para compra</span>'
          case (t.estado == 4 && t.compra == 1):
            return '<span class="tag is-warning">Para compra</span>'
          case (t.estado == 5 && t.compra == 1):
            return '<span class="tag is-warning">Para compra</span>'
          case (t.estado == 6 && t.compra == 1):
            return ''
          case (t.estado == 1 && t.compra == 0):
            return '<span class="tag is-ligth">Reparado</span>'
          case (t.estado == 2 && t.compra == 0):
            return '<span class="tag is-ligth">Reparado</span>'
          case (t.estado == 3 && t.compra == 0):
            return '<span class="tag is-ligth">Reparado</span>'
          case (t.estado == 4 && t.compra == 0):
            return '<span class="tag is-ligth">Reparado</span>'
          case (t.estado == 5 && t.compra == 0):
            return '<span class="tag is-ligth">Reparado</span>'
          case (t.estado == 6 && t.compra == 0):
            return ''
        }

      },
      imprimirReporte(t) {
        this.$emit('printReport', t)
      }
    },
    computed: {
      ...mapState(['logueado', 'userLogin', 'area_soporte'])
    }
  }
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/soporte_Componentes/Tb_Tickets.vue